export const VERIFICATION_PRE_SORTIE_TEXT =
  process.env.REACT_APP_COMMON_VERIFICATION_PRE_SORTIE_TEXT || '';
